export var CashType;
(function (CashType) {
    CashType["RMB"] = "rmb";
    CashType["USDT"] = "usdt";
})(CashType || (CashType = {}));
//# sourceMappingURL=CashType.js.map